import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function DollarCoin({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>DollarCoin</title>
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.5381C10 14.3166 10.6238 14.9478 11.3933 14.9478L12.6871 14.9478C13.5116 14.9478 14.18 14.2715 14.18 13.4374C14.18 12.6032 13.5116 11.927 12.6871 11.927L11.4929 11.927C10.6684 11.927 10 11.2508 10 10.4166C10 9.58245 10.6684 8.90623 11.4929 8.90623L12.7867 8.90623C13.5562 8.90623 14.18 9.53737 14.18 10.3159M12.09 8L12.09 8.90623M12.09 14.9478L12.09 15.854"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
